import { useEffect, useState } from 'react'
import { getBidHistory } from '@/services/api/bids'
import { formatPrice } from '@/utils/format'
import type { Bid } from '@/types/bid'

export function SellerBidList({ listingId }: { listingId: string }) {
  const [bids, setBids] = useState<Bid[]>([])
  const [loading, setLoading] = useState(true)
  useEffect(() => {
    getBidHistory(listingId)
      .then(setBids)
      .catch(() => setBids([]))
      .finally(() => setLoading(false))
  }, [listingId])

  if (loading) return <p className="text-sm text-slate-500">Loading bids…</p>
  if (bids.length === 0) return <p className="text-sm text-slate-500">No bids yet.</p>

  return (
    <div className="card p-4">
      <h3 className="font-semibold mb-3">Bids ({bids.length})</h3>
      <ul className="divide-y divide-slate-100">
        {bids.map((b) => (
          <li key={b.id} className="flex items-center justify-between py-2 text-sm">
            <span className="text-slate-700">
              {b.bidderName && b.bidderName.toLowerCase() !== 'anonymous' ? b.bidderName : 'Bidder'}
              {b.isAutoBid && <span className="ml-2 text-xs text-slate-400">(auto)</span>}
            </span>
            <span className="font-medium">{formatPrice(b.amount)}</span>
          </li>
        ))}
      </ul>
    </div>
  )
}
